window.Velocity = require('velocity-animate');

require('waypoints/lib/noframework.waypoints.min.js');

/*=============================
=          Initialize         =
=============================*/

window.hero = document.getElementById('hero');
window.main = document.querySelector('main');
window.footer = document.getElementById('footer');
window.header = document.getElementById('header');
window.headerHeight = header ? header.offsetHeight : 0;
window.topbar = document.getElementById('topbar');
window.topbarHeight = topbar ? topbar.offsetHeight : 0;
window.isSpanish = document.documentElement.lang == 'es';

// !function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.Promise = require('promise-polyfill').default;

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

var token = document.head.querySelector('meta[name="csrf-token"]');

if(token) {
	window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

/*=============================
=      Check Window Width     =
=============================*/

window.checkWidth = function checkWidth(width) {
	return window.innerWidth < width;
};

/*=============================
=       Lazyload Scripts      =
=============================*/

window.scriptWaypoint = function scriptWaypoint(el, src, offset) {
	var scriptWaypoint = new Waypoint({
		element: el,
		handler: function(direction) {
			addJS(src);

			this.destroy();
		},
		offset: offset
	});
};

window.addJS = function addJS(src) {
	var script = document.createElement('script');

	script.src = src;
	script.type = 'text/javascript';
	script.setAttribute('async', 'true');
	script.setAttribute('defer', 'true');

	document.body.appendChild(script);
};

/*=============================
=       Scroll To Element     =
=============================*/

window.scrollToElement = function scrollToElement(scrollTo) {
	Velocity(scrollTo, 'scroll', {duration: 800, offset: -(checkWidth(768) ? document.getElementById('nav-wrap').offsetHeight : headerHeight)});
};

/*=============================
=       Get URL Parameter     =
=============================*/

window.getParameter = function getParameter(obj, parameter) {
	var value = '';

	obj.href.split('&').forEach(function(param) {
		if(param.indexOf(parameter) > -1)
			value = param.split(parameter+'=')[1];
	});

	return value;
};

/*=============================
=       Google Map Styles     =
=============================*/

window.mapStyles = [
	{
		"featureType": "all",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "on"
			},
			{
				"color": "#454545"
			}
		]
	},
	{
		"featureType": "all",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.country",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "administrative.country",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "administrative.country",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "on"
			},
			{
				"weight": "0.01"
			}
		]
	},
	{
		"featureType": "administrative.locality",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.locality",
		"elementType": "labels.text",
		"stylers": [
			{
				"weight": "0.01"
			},
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "administrative.locality",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"weight": "0.01"
			}
		]
	},
	{
		"featureType": "administrative.neighborhood",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.neighborhood",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"weight": "0.01"
			}
		]
	},
	{
		"featureType": "administrative.land_parcel",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "landscape.man_made",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "landscape.natural",
		"elementType": "all",
		"stylers": [
			{
				"color": "#c4ecff"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "poi.government",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "poi.school",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "poi.sports_complex",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"color": "#f6fbfe"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"weight": "0.50"
			},
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels.text",
		"stylers": [
			{
				"weight": "0.01"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"weight": "0.01"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "on"
			},
			{
				"weight": "0.01"
			}
		]
	},
	{
		"featureType": "road.highway.controlled_access",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "labels.text",
		"stylers": [
			{
				"color": "#7e7e7e"
			},
			{
				"weight": "0.01"
			},
			{
				"gamma": "1.07"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "transit",
		"elementType": "all",
		"stylers": [
			{
				"weight": "0.01"
			},
			{
				"color": "#8ed5f8"
			}
		]
	},
	{
		"featureType": "transit",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"gamma": "2.49"
			},
			{
				"color": "#8f8f8f"
			}
		]
	},
	{
		"featureType": "transit",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"gamma": "0.59"
			}
		]
	},
	{
		"featureType": "transit.line",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "on"
			},
			{
				"weight": "5.07"
			}
		]
	},
	{
		"featureType": "transit.line",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "transit.station.airport",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "transit.station.bus",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "transit.station.rail",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "all",
		"stylers": [
			{
				"color": "#dff5ff"
			}
		]
	}
];

/*=============================
=            Segment          =
=============================*/

window.getTrackingParameters = function getTrackingParameters() {
	// Get Facebook/Meta Cookies
	var fbp = '';
	var fbc = '';

	if(Cookie.get('_fbp')) {
		fbp = Cookie.get('_fbp');
	}

	if(Cookie.get('_fbc')) {
		fbc = Cookie.get('_fbc');
	}

	// Get UTM values from Custom Cookie
	const utmCookie = Cookie.get('utm_params');
	var utms = utmCookie ? JSON.parse(utmCookie) : {};

	var utm_source = utms.utm_source && utms.utm_source !== null ? utms.utm_source : '';
	var utm_medium = utms.utm_medium && utms.utm_medium !== null ? utms.utm_medium : '';
	var utm_campaign = utms.utm_campaign && utms.utm_campaign !== null ? utms.utm_campaign : '';
	var utm_content = utms.utm_content && utms.utm_content !== null ? utms.utm_content : '';
	var utm_term = utms.utm_term && utms.utm_term !== null ? utms.utm_term : '';
	var ga_client_id = Cookie.get('_ga') ? Cookie.get('_ga').slice(6) : '';
	var fbclid = utms.fbclid && utms.fbclid !== null ? utms.fbclid : '';
	var sccid = utms.sccid && utms.sccid !== null ? utms.sccid : '';
	var ttclid = utms.ttclid && utms.ttclid !== null ? utms.ttclid : '';
	var ob_click_id = utms.ob_click_id && utms.ob_click_id !== null ? utms.ob_click_id : '';
	var tb_click_id = utms.tb_click_id && utms.tb_click_id !== null ? utms.tb_click_id : '';
	var msclkid = utms.msclkid && utms.msclkid !== null ? utms.msclkid : '';
	var gclid = utms.gclid && utms.gclid !== null ? utms.gclid : '';
	var gbraid = utms.gbraid && utms.gbraid !== null ? utms.gbraid : '';
	var wbraid = utms.wbraid && utms.wbraid !== null ? utms.wbraid : '';
	var oppref = utms.oppref && utms.oppref !== null ? utms.oppref : '';

	return {
		full_url: window.location.href,
		landing_full_url: Cookie.get('landing_full_url'),
		utm_source,
		utm_medium,
		utm_campaign,
		utm_content,
		utm_term,
		ga_client_id,
		fbclid,
		sccid,
		ttclid,
		ob_click_id,
		tb_click_id,
		msclkid,
		gclid,
		gbraid,
		wbraid,
		fbp,
		fbc,
		oppref
	};
};

window.segmentTracking = function segmentTracking(eventName, params) {
	// Tracking parameters
	const tracking = getTrackingParameters();

	// Segment AnonymousId
	const anonymousId = Cookie.get('segment_anonymousId');

	// Merge all parameters
	const trackParams = {...params, ...tracking};

	// Identify
	analytics.identify(null, params, function() {
		// Track
		analytics.track(eventName, trackParams, {
			anonymousId
		});
	});
};

/*=============================
=       URL Persistence       =
=============================*/

var params = {};
var trackingParams = [
	'utm_source',
	'utm_medium',
	'utm_campaign',
	'utm_content',
	'utm_term',
	'fbclid',
	'sccid',
	'ttclid',
	'ob_click_id',
	'tb_click_id',
	'msclkid',
	'gclid',
	'gbraid',
	'wbraid',
	'oppref'
];

window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str, key, value) {
	if(trackingParams.includes(key)) {
		params[key] = value;
	}
});

if(Object.keys(params).length) {
	var links = document.querySelectorAll('a:not([href^="tel:"]):not([href^="mailto:"]), .link:not([href^="tel:"]):not([href^="mailto:"])');

	links.forEach(function(link) {
		var isLinkEl = link.hasAttribute('data-href'),
			originalHref = isLinkEl ? link.dataset.href : link.href;

		for(var key in params) {
			if(params.hasOwnProperty(key) && !originalHref.includes(key)) {
				if(originalHref.includes('?')) {
					originalHref += '&' + key + '=' + params[key];
				} else {
					originalHref += '?' + key + '=' + params[key];
				}
			}
		}

		if(isLinkEl) {
			link.dataset.href = originalHref;
		} else {
			link.href = originalHref;
		}
	});
}

/*=============================
=        Keyboard Focus       =
=============================*/

document.addEventListener('keydown', function(e) {
	if(e.code == 'Tab' && !body.classList.contains('tabbing')) {
		body.classList.add('tabbing');
	}
});

document.addEventListener('mousedown', function() {
	if(body.classList.contains('tabbing')) {
		body.classList.remove('tabbing');
	}
});